module.exports = __webpack_public_path__ + "img/minoxidil_cropped.51249adf.png";